var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section", attrs: { id: "maksutapa" } },
    [
      [
        _c("h2", { staticClass: "section__heading section__heading--alt2" }, [
          _vm._v(
            "\n      4. " + _vm._s(_vm.$modeoL10n.payment_method) + "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkout__rows" }, [
          _c("div", { staticClass: "checkout__header" }, [
            _c("label", { staticClass: "checkout__header__field" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedPaymentMethod,
                    expression: "selectedPaymentMethod"
                  }
                ],
                staticClass: "radio-input",
                attrs: {
                  type: "radio",
                  name: "payment_method",
                  value: "paytrail"
                },
                domProps: {
                  checked: _vm._q(_vm.selectedPaymentMethod, "paytrail")
                },
                on: {
                  change: [
                    function($event) {
                      _vm.selectedPaymentMethod = "paytrail"
                    },
                    function($event) {
                      return _vm.paymentMethodChanged()
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "checkout__header__heading radio-label" },
                [_vm._v(_vm._s(_vm.$modeoL10n.payment_method_checkoutfi))]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.selectedPaymentMethod == "paytrail"
            ? _c(
                "div",
                {
                  staticClass:
                    "checkout__subsection checkout__subsection--payment"
                },
                [
                  _c(
                    "ul",
                    { staticClass: "checkout__payment-types" },
                    _vm._l(_vm.getPaymentTypes(), function(type, index) {
                      return _c("li", { key: index }, [
                        _c("span", [
                          _vm._v("\n              " + _vm._s(type.title)),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "checkout__payment-description" },
                            [_vm._v(_vm._s(type.description))]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "checkout__payment-providers" },
                          [
                            _vm._l(type.providers, function(provider) {
                              return [
                                _c(
                                  "span",
                                  {
                                    key: provider.slug,
                                    class: [
                                      "checkout__payment-logo",
                                      "checkout__payment-logo--" + provider.slug
                                    ]
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "screen-reader-text" },
                                      [_vm._v(_vm._s(provider.name))]
                                    )
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ])
                    }),
                    0
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__header" }, [
            _c("label", { staticClass: "checkout__header__field" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedPaymentMethod,
                    expression: "selectedPaymentMethod"
                  }
                ],
                staticClass: "radio-input",
                attrs: {
                  type: "radio",
                  name: "payment_method",
                  value: "klarna_payments"
                },
                domProps: {
                  checked: _vm._q(_vm.selectedPaymentMethod, "klarna_payments")
                },
                on: {
                  change: [
                    function($event) {
                      _vm.selectedPaymentMethod = "klarna_payments"
                    },
                    function($event) {
                      return _vm.paymentMethodChanged()
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "checkout__header__heading radio-label" },
                [_vm._v(_vm._s(_vm.$modeoL10n.payment_method_klarna))]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.selectedPaymentMethod == "klarna_payments"
            ? _c(
                "div",
                {
                  staticClass:
                    "checkout__subsection checkout__subsection--payment"
                },
                [
                  _c(
                    "ul",
                    { staticClass: "checkout__payment-types" },
                    _vm._l(_vm.getKlarnaPaymentTypes(), function(type, index) {
                      return _c("li", { key: index }, [
                        _c("span", [
                          _vm._v("\n              " + _vm._s(type.title)),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "checkout__payment-description" },
                            [_vm._v(_vm._s(type.description))]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "checkout__payment-providers" },
                          [
                            _vm._l(type.providers, function(provider) {
                              return [
                                _c(
                                  "span",
                                  {
                                    key: provider.slug,
                                    class: [
                                      "checkout__payment-logo",
                                      "checkout__payment-logo--" + provider.slug
                                    ]
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "screen-reader-text" },
                                      [_vm._v(_vm._s(provider.name))]
                                    )
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ])
                    }),
                    0
                  )
                ]
              )
            : _vm._e()
        ])
      ],
      _vm._v(" "),
      _c("section", { staticClass: "section" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("termsAndConditions"),
                expression: "errors.has('termsAndConditions')"
              }
            ],
            staticClass: "error-notification"
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.errors.first("termsAndConditions")) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "checkout__rows" }, [
          _c("div", { staticClass: "checkout__header" }, [
            _c("label", { staticClass: "checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.termsAndConditions,
                    expression: "termsAndConditions"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "checkbox-input",
                attrs: {
                  id: "termsAndConditions",
                  type: "checkbox",
                  name: "termsAndConditions"
                },
                domProps: {
                  checked: Array.isArray(_vm.termsAndConditions)
                    ? _vm._i(_vm.termsAndConditions, null) > -1
                    : _vm.termsAndConditions
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.termsAndConditions,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.termsAndConditions = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.termsAndConditions = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.termsAndConditions = $$c
                      }
                    },
                    function($event) {
                      return _vm.fieldChanged()
                    }
                  ],
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "checkout__header__heading checkbox-label checkbox-label--last"
                },
                [_vm._v(_vm._s(_vm.$modeoL10n.terms) + " *")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "checkout__header__link",
                  attrs: { href: _vm.$modeoL10n.terms_link, target: "_blank" }
                },
                [_vm._v(_vm._s(_vm.$modeoL10n.terms_link_text))]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "woocommerce-checkout-payment" }, [
        _c("div", { staticClass: "form-row place-order" }, [
          _c(
            "div",
            {
              staticClass:
                "checkout__button__container checkout__button__container--back"
            },
            [
              _c(
                "a",
                {
                  staticClass:
                    "checkout__button checkout__button--back btn btn--secondary btn--block",
                  attrs: { href: _vm.$modeoL10n.url_shop }
                },
                [_vm._v(_vm._s(_vm.$modeoL10n.return_to_shop))]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__button__container" }, [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "checkout__button btn btn--block",
                  attrs: { type: "submit", name: _vm.formName },
                  on: {
                    click: function($event) {
                      return _vm.submit()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$modeoL10n.proceed_to_payment) +
                      "\n            "
                  ),
                  _vm._v(" "),
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm._f("formatPrice")(_vm.total)) +
                        "\n            "
                    )
                  ]
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.sectionsWithErrors.length > 0,
                    expression: "sectionsWithErrors.length > 0"
                  }
                ],
                staticClass: "checkout__errors"
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$modeoL10n.errors_in_form) +
                    " " +
                    _vm._s(_vm.$modeoL10n.errors_in_checkout_form) +
                    "\n          "
                ),
                _vm._l(_vm.sectionsWithErrors, function(section, index) {
                  return _c(
                    "a",
                    { key: section.id, attrs: { href: "#" + section.id } },
                    [
                      _vm._v(_vm._s(section.label)),
                      index < _vm.sectionsWithErrors.length - 1
                        ? _c("span", [_vm._v(", ")])
                        : _vm._e()
                    ]
                  )
                }),
                _vm._v(".\n        ")
              ],
              2
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c33229e", { render: render, staticRenderFns: staticRenderFns })
  }
}